import { createContext } from "preact";

export const GrantsContext = createContext<string[]>([])
